// extracted by mini-css-extract-plugin
module.exports = {"bookmarksList":"index_bookmarksList__1JrZO","bookmarksItem":"index_bookmarksItem__P8s2P","activeSection":"index_activeSection__27lsF","dot":"index_dot__21Uby"};